var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var ActivePageSection = require('common/util/ActivePageSection');
var Session = require('psa-core/Session');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');

var COCEntitySearchView = require('../views/COCEntitySearchView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  var searchLimit = Session.config.CM_ELASTICSEARCH_MAX_RESULTS || 1000;
  $.when(GetAllEntityLookups())
    .done(function(lookups) {
      NavUtils.navigate('coc/dashboard/entity-search');

      Scaffold.content.show(
        new COCEntitySearchView({
          model: new Backbone.Model({
            entityTypes: lookups.entityTypes,
            organizationTypes: lookups.organizationTypes,
            searchLimit: searchLimit
          })
        })
      );

      ActivePageSection.empty();
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
